import React from 'react';
import { useSelector } from 'react-redux';
import { CenterFrameLayout } from 'Layouts';
import './CurrentSubscriberMilitaryFirst.css';
import { getSheerIdType } from 'Utils/SheerIdHelpers';
import { SHEER_MILITARY_TYPE } from 'Utils/Constants';

export const CurrentSubscriberMilitaryFirst = () => {
  const { sheerIdUrl } = useSelector((s) => s.appConfig.defaultConfig);
  const isMilitary = getSheerIdType() === SHEER_MILITARY_TYPE;
  const headerTitle = isMilitary ? 'Military & Veterans 1-Year Free Offer' : 'First Responders 1-Year Free Offer';

  return (
    <CenterFrameLayout title={headerTitle}>
      <div className="currentSubscriberMilitaryFirst">
        <a className="sheerIdUrl" href={sheerIdUrl}>
          &lt; Back to Main Offer Page
        </a>
        <div className="instructions">You already have a FOX Nation account.</div>
        <div className="instructions">
          To take advantage of this promotion, please contact Customer Care by visiting us{' '}
          <a className="linkText" href="https://help.fox.com/fox/s/topic/0TO1H000000HHQUWA4/fox-nation">
            here
          </a>
          .
        </div>
      </div>
    </CenterFrameLayout>
  );
};
